<template>
  <div class="row mb-4">
    <div class="col-md-2">
      <select v-model="limit" class="form-select">
        <option>10</option>
        <option>25</option>
        <option>50</option>
      </select>
    </div>
    <div class="col-md-4 ms-auto">
      <div class="input-group">
        <input
          v-model="searchTerm"
          type="text"
          class="form-control"
          placeholder="Search invoices.."
        />
        <span class="input-group-text bg-body border-0">
          <i class="fa fa-search"></i>
        </span>
      </div>
    </div>
  </div>

  <datatable
    :url="ajaxUrl"
    :limit="limit"
    :order-by="orderBy"
    :order-asc="orderAsc"
    :search="searchTerm"
  >
    <template #headings>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="invoice_number"
        @set-order-by="setOrder"
      >
        Invoice
      </sortableTh>
      <th>Customer</th>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="status"
        @set-order-by="setOrder"
      >
        Status
      </sortableTh>
      <th>Amount</th>
      <sortableTh
        :current-order-by="orderBy"
        :order-asc="orderAsc"
        order-by="created_at"
        @set-order-by="setOrder"
      >
        Created
      </sortableTh>
      <th></th>
    </template>
    <template #rows="{ data }">
      <tr v-for="invoice in data" :key="invoice.id">
        <td>{{ invoice.invoice_number ?? "Not synced" }}</td>
        <td>{{ invoice.customer }}</td>
        <td>
          <span :class="invoice.status_class">{{ invoice.status }}</span>
        </td>
        <td>{{ invoice.total_price }}</td>
        <td>{{ invoice.created }}</td>
        <td v-html="invoice.actions"></td>
      </tr>
    </template>
  </datatable>
</template>

<script setup>
import { ref } from "vue";
import datatable from "@/components/datatable.vue";
import sortableTh from "@/components/datatable/sortableTh.vue";

defineProps({
  ajaxUrl: {
    type: String,
    required: true,
  },
});

const orderBy = ref("created_at");
const orderAsc = ref(false);
const limit = ref(25);
const searchTerm = ref(null);

const setOrder = function (input) {
  if (orderBy.value == input) {
    orderAsc.value = !orderAsc.value;
  } else {
    orderBy.value = input;
    orderAsc.value = true;
  }
};
</script>
